export default "__VITE_ASSET__DSVzVkux__"